import { useEffect, useRef, useState } from "react";
import { Filters } from "consts/openBanking";
import { Paginate } from "consts/table";
import { when } from "util/support";
import { RequestQueryMapper } from "util/request-query-mapper";
import { useSimpleRequest } from "hooks/useRequest";
import { getIbanXsBanksCountriesPivot } from "features/openBanking/api";
import type { IbanXsBank, IbanXsBanksCountriesPivotResponse } from "features/openBanking/types";
import { useResourceContext } from "ui/widgets/Resource";
import { initialState } from "./IbanXSBanksCountriesPivotContext";
import type { IbanXSBanksCountriesPivotContext } from "./types";

export default function useIbanXSBanksCountriesPivot() {
    const { resource } = useResourceContext<IbanXsBank>();

    const request = useSimpleRequest();
    const requestRef = useRef(request);
    requestRef.current = request;

    const [state, setState] = useState<IbanXSBanksCountriesPivotContext>(initialState);

    const { bankId } = resource ?? {};

    useEffect(() => {
        when(bankId, () => {
            setState(state => ({
                ...state,
                isLoading: true
            }));

            requestRef.current(() => getIbanXsBanksCountriesPivot(
                RequestQueryMapper.from()
                    .containsIn(Filters.bankId, `${bankId}`)
                    .contains(Paginate.perPage, '1')
                    .toString()
            ), {
                onSuccess: ({ data }: IbanXsBanksCountriesPivotResponse) => (
                    setState(state => ({
                        ...state,
                        pivot: data.data.at(0) ?? null
                    }))
                )
            })
            .finally(() => (
                setState(state => ({
                    ...state,
                    isLoading: false
                })
            )));
        });
    }, [bankId]);

    return state;
};
